import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEn from './locale/en.json'
import translationDe from './locale/de.json'
import translationAr from './locale/ar.json'


i18n.use(LanguageDetector).use(initReactI18next).init({
        debug: true,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        },
    
        lng:'ar',
        resources:{
            en:{
                translation:translationEn
            },
            ar:{
                translation:translationAr
            },
            de:{
                translation:translationDe
            }
        }
    })


export default i18n;